import { useRef } from 'react';

const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20landscape%20with%20warm%20sunset%20sky%2C%20dramatic%20clouds%2C%20golden%20light%20rays%2C%20film%20texture%20overlay%2C%20movie%20poster%20aesthetic%2C%20grand%20scale%20composition%2C%20rich%20warm%20tones%2C%20professional%20cinematography&width=900&height=500&seq=carousel-bajie-01&orientation=landscape',
    tag: '焦点专题',
    title: '暑期档必看十大电影',
    desc: '今年暑期档佳片云集，从国产大片到进口巨制，我们为你盘点最值得走进电影院的十部作品。',
    stat: '热度 9.8',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20visual%20style%20with%20dark%20atmosphere%2C%20dramatic%20shadow%20play%2C%20warm%20accent%20lighting%2C%20film%20noir%20composition%2C%20suspenseful%20mood%2C%20cinematic%20quality%2C%20rich%20contrast%2C%20mysterious%20elegant%20aesthetic&width=900&height=500&seq=carousel-bajie-02&orientation=landscape',
    tag: '编辑精选',
    title: '烧脑悬疑片单：反转再反转',
    desc: '喜欢挑战智商的观众有福了，这份悬疑片单收录了近年来口碑最好的烧脑佳作。',
    stat: '评分 9.2',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20family%20living%20room%20scene%20with%20TV%20screen%20glow%2C%20cozy%20evening%20atmosphere%2C%20soft%20lamp%20light%2C%20comfortable%20sofa%2C%20home%20entertainment%20lifestyle%2C%20relaxing%20mood%2C%20cinematic%20composition%2C%20warm%20amber%20tones&width=900&height=500&seq=carousel-bajie-03&orientation=landscape',
    tag: '追剧指南',
    title: '2026下半年最期待剧集',
    desc: '各大平台下半年片单已公布，多部重磅剧集蓄势待发，这份追剧日历请收好。',
    stat: '期待值 9.5',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20retro%20aesthetic%20with%20vintage%20movie%20camera%2C%20old%20film%20reels%2C%20warm%20sepia%20tones%2C%20nostalgic%20cinema%20atmosphere%2C%20golden%20age%20Hollywood%20vibe%2C%20rich%20textures%2C%20elegant%20composition&width=900&height=500&seq=carousel-bajie-04&orientation=landscape',
    tag: '经典重温',
    title: '那些年我们追过的经典港片',
    desc: '从武侠到警匪，从喜剧到爱情，香港电影的黄金时代留下了无数值得反复回味的经典。',
    stat: '收藏 5.6万',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Anime%20art%20exhibition%20style%20colorful%20illustration%2C%20vibrant%20character%20designs%2C%20warm%20magical%20atmosphere%2C%20cherry%20blossom%20and%20soft%20light%2C%20Japanese%20animation%20aesthetic%2C%20dreamy%20composition%2C%20rich%20warm%20color%20palette&width=900&height=500&seq=carousel-bajie-05&orientation=landscape',
    tag: '动漫专题',
    title: '宫崎骏动画电影全盘点',
    desc: '从《千与千寻》到《你想活出怎样的人生》，宫崎骏用一部部作品治愈了无数人的心灵。',
    stat: '播放 128万',
  },
];

export default function Carousel() {
  const containerRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    const el = containerRef.current;
    if (!el) return;
    const scrollAmount = el.clientWidth * 0.8;
    el.scrollBy({ left: dir === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
  };

  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.style.display = 'none';
  };

  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              焦点专题
            </h2>
            <p className="text-sm text-foreground-500">深度策划，带你发现更多精彩影视世界</p>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 border border-background-300/60 hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 border border-background-300/60 hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>

        <div
          ref={containerRef}
          className="flex gap-5 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-2"
          style={{ scrollbarWidth: 'none' }}
        >
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group flex-shrink-0 w-[320px] md:w-[360px] snap-start rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:-translate-y-1 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="900"
                  height="500"
                  onError={handleImgError}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 text-xs font-medium text-background-50 whitespace-nowrap">
                  {item.stat}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}